export default __webpack_public_path__ + "static/media/data-processing-white.29e427e9.png";